import {CardActions, styled} from '@mui/material';

export const StyledCardActions = styled(CardActions)`
	padding: 0 8px 16px;
	justify-content: flex-end;
`;
